import {FC, FormEvent, ReactNode, useCallback} from 'react';
import {styled} from 'styled-components';

import {Button} from '@shared_web/components/core/button';
import {hideModal} from '@shared_web/components/core/modal';

import {Translate} from '@mavismart_frontend/components/translate';
import {BUTTON_THEME2, BUTTON_THEME} from '@mavismart_frontend/lib/constants';

interface GenericModalFormProps {
  onSubmit: (event: FormEvent) => void;
  loading?: boolean;
  childrenInput: ReactNode;
}

export const GenericModalForm: FC<GenericModalFormProps> = props => {
  const {onSubmit, loading, childrenInput} = props;

  const onSubmitInternal = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      onSubmit(event);
    },
    [onSubmit]
  );

  return (
    <FormStyled onSubmit={onSubmitInternal}>
      {childrenInput}

      <WrapperButtons>
        <Button type="button" expand themeOverrides={BUTTON_THEME2} onClick={hideModal}>
          <Translate value="cancel" />
        </Button>
        <Button type="submit" expand themeOverrides={BUTTON_THEME} loading={loading}>
          <Translate value="save" />
        </Button>
      </WrapperButtons>
    </FormStyled>
  );
};

GenericModalForm.displayName = 'GenericModalForm';

const FormStyled = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  `;

const WrapperButtons = styled.div`
    display: flex;
    gap: 20px;
    width: 100%
  `;
